import { render, staticRenderFns } from "./TrademarkOrder.vue?vue&type=template&id=5e521a39&scoped=true"
import script from "./TrademarkOrder.vue?vue&type=script&lang=js"
export * from "./TrademarkOrder.vue?vue&type=script&lang=js"
import style0 from "./TrademarkOrder.vue?vue&type=style&index=0&id=5e521a39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e521a39",
  null
  
)

export default component.exports